import { getCookie, setCookie } from "cookies/cookie";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function CookieBar(): JSX.Element {
  const location = useLocation();
  const cookieBar = useRef<HTMLDivElement | null>(null);
  const timer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const cookieConsent = getCookie("cookie_consent");
    if (!cookieConsent) {
      const cookieBarElement = document.querySelector(".cky-consent-container");
      if (cookieBarElement) {
        cookieBarElement.classList.remove("cky-hide");
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const cookieBarElement = document.querySelector(".cky-consent-container");
      if (
        target &&
        (target.classList.contains("cky-btn-do-not-sell") ||
          target.closest(".cky-btn-do-not-sell"))
      ) {
        setCookie({
          name: "cookie_consent",
          value: "true",
          options: {
            path: "/",
            expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
          },
        });
        if (cookieBarElement && !cookieBar.current) {
          cookieBar.current = cookieBarElement as HTMLDivElement;
        }
      }
      const cookieConsent = getCookie("cookie_consent");
      if (cookieConsent && cookieBarElement) {
        cookieBarElement.classList.add("cky-hide");
      }
    };

    const cookieConsent = getCookie("cookie_consent");
    const closeCookieBar = () => {
      const cookieBarElement = document.querySelector(
        ".cky-consent-container"
      ) as HTMLElement;
      if (cookieBarElement) {
        cookieBarElement.style.opacity = "1";
        if (cookieConsent) {
          cookieBarElement.classList.add("cky-hide");
        }
      }
    };
    const findCookieBar = () => {
      const cookieBarElement = document.querySelector(".cky-consent-container");
      const { cookieyes } = window as any;
      if (cookieBarElement && cookieyes) {
        if (timer.current) {
          clearTimeout(timer.current);
        }
        closeCookieBar();
      } else {
        timer.current = setTimeout(findCookieBar, 100);
      }
    };
    findCookieBar();
    window.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("click", handleClick);
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);
  return <></>;
}
